import type { Form } from 'antd';
import cn from 'classnames';
import ReactPhoneInput, { type Value } from 'react-phone-number-input';
import { Item } from '../item';

type InputP = {
  autoComplete?: string;
  onChange?: (value?: Value) => void;
  placeholder?: string;
  value?: Value;
};

type ItemP = {
  hidden?: boolean;
  label?: string;
} & Omit<React.ComponentProps<typeof Form.Item>, 'children' | 'label'>;

type P = {
  input?: InputP;
  item: ItemP;
};

const Input = ({ onChange, value, ...rest }: InputP) => {
  const handleOnChange = (newValue?: Value) => onChange?.(newValue);

  return <ReactPhoneInput defaultCountry="US" onChange={handleOnChange} value={value} {...rest} />;
};

const PhoneInput = ({ input, item: { className, ...itemRest } }: P) => (
  <Item className={cn(className, 'form-phone-input')} {...itemRest}>
    <Input {...input} />
  </Item>
);

export default PhoneInput;
